module.exports = __webpack_public_path__ + "img/data-quality-music-publishers-level-3.e5feb2a9.svg";